import OxbridgeLandingPage from './OxbridgeLandingPage';
export default OxbridgeLandingPage;
